import { render, staticRenderFns } from "./DrugDetail.vue?vue&type=template&id=02382b14&scoped=true"
import script from "./DrugDetail.vue?vue&type=script&lang=js"
export * from "./DrugDetail.vue?vue&type=script&lang=js"
import style0 from "./DrugDetail.vue?vue&type=style&index=0&id=02382b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02382b14",
  null
  
)

export default component.exports